<div class="row my-5">
  <div class="col-12 mb-5">
    <h1>HASZNÁLATI ÚTMUTATÁS SIKET ÉS NAGYOTHALLÓK RÉSZÉRE</h1>
  </div>
  <div class="col-12 mb-5">
    <p>
      Itt találsz jelnyelven segítséget szolgáltatásainkra vonatkozóan.
      Jelnyelvi szaktanácsadóinkkal egyeztetve választottuk ki a FOXPOST
      használattal kapcsolatos legfontosabb témákat.
    </p>
  </div>
</div>
@for(v of videos; track v.title){
<div class="row mx-auto mb-5">
  <div
    class="align-items-center d-flex justify-content-center ms-auto"
    [class.order-1]="v.layout === 'right'"
    style="
      height: 300px;
      width: 600px;
      background-repeat: no-repeat;
      background-position: center left;
    "
    [ngStyle]="{ 'background-image': `url(${v.coverImage})` }"
  >
    <mat-icon
      fontIcon="play_circle_outline"
      class="play-button"
      style="cursor: pointer"
      (click)="openDialog(v.title, v.videoLink)"
    ></mat-icon>
  </div>
  <div
    [class.order-0]="v.layout === 'right'"
    [class.ms-auto]="v.layout === 'right'"
    [class.text-end]="v.layout === 'right'"
    [class.me-auto]="v.layout === 'left'"
    [class.col-5]="v.layout === 'left'"
    [class.col]="v.layout === 'right'"
  >
    <h2>{{ v.title }}</h2>
    <br />
    <a
      [href]="v.buttonLink"
      mat-stroked-button
      class="mt-2 secondary-btn h-auto"
      matRipple
      *ngIf="v.buttonLink.length"
    >
      {{ v.buttonText }}
    </a>
  </div>
</div>
}
